import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const APCounter = ({
  count,
  color = "primary",
}: {
  count: string;
  color: "primary" | "secondary";
}) => {
  return (
    <Box
      sx={{
        backgroundColor: `${color}.main`,
        borderRadius: "100%",
        padding: "0.25rem 0.5rem",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "1.25rem",
        width: "1.25rem",
      }}
    >
      <Typography variant="bodySmall" display="inline" fontWeight={600}>
        {count}
      </Typography>
    </Box>
  );
};

export default APCounter;
